<template>
	<div id="top" class="site-shell">
		<SiteHeader />
		<main id="main" class="public-main">
			<section class="public-hero">
				<div class="public-hero-inner">
					<div class="public-breadcrumb"><router-link to="/">Home</router-link><span>/</span><span>{{ group }}</span></div>
					<span class="section-kicker"><span>{{ chapter }}</span> / {{ eyebrow }}</span>
					<h1>{{ title[0] }}<br /><em>{{ title[1] }}</em></h1>
					<p>{{ lead }}</p>
				</div>
				<div class="public-hero-orbit" aria-hidden="true"><i /><i /></div>
				<span class="public-hero-corner" aria-hidden="true">PAYDECK / INDIA</span>
			</section>
			<slot v-if="wide" />
			<div v-else class="public-content-wrap">
				<aside class="public-sidebar" aria-label="Public pages">
					<p>EXPLORE PAYDECK</p>
					<router-link v-for="(link, index) in publicLinks" :key="link.href" :to="link.href" :aria-current="link.href === current ? 'page' : null">
						<span>{{ String(index + 1).padStart(2, "0") }}</span>{{ link.label }}<ArrowUpRight :size="15" />
					</router-link>
				</aside>
				<article class="public-article">
					<slot />
				</article>
			</div>
			<div class="public-endnote"><span>PAYDECK INDIA · SINCE 2014</span><router-link to="/">Explore the home page <ArrowUpRight :size="18" /></router-link></div>
		</main>
		<SiteFooter />
	</div>
</template>

<script setup>
import { computed } from "vue";
import { ArrowUpRight } from "lucide-vue-next";
import SiteHeader from "./SiteHeader.vue";
import SiteFooter from "./SiteFooter.vue";
import { publicLinks } from "@/content/site";

const props = defineProps({
	current: { type: String, required: true },
	eyebrow: { type: String, required: true },
	title: { type: Array, required: true },
	lead: { type: String, required: true },
	/** Full width storytelling layout: no sidebar, the slot renders its own sections */
	wide: { type: Boolean, default: false }
});

const index = computed(() => publicLinks.findIndex((link) => link.href === props.current));
const group = computed(() => (index.value >= 0 ? publicLinks[index.value].group : "Paydeck"));
const chapter = computed(() => String(index.value + 1).padStart(2, "0"));
</script>
